<template>
  <dialog-modal-fi
    ref="dialog"
    class="media-download-dialog-fi modal-fi--content-width-sm modal-fi--action-buttons modal-fi--mobile-fullscreen"
    lazy
    @before-close="beforeClose"
  >
    <template #header>
      <richtext-fi
        v-if="fields.mediaDownloadDialogText"
        class="media-download-dialog-fi__text"
        :html-content="fields.mediaDownloadDialogText"
      />
    </template>
    <template #footer>
      <div class="media-download-dialog-fi__button">
        <loading-indicator-wrapper
          :loading="isLoading"
          variant="spinnerLocal"
          spinoff="in-relative-centered"
        >
          <a
            download
            :disabled="isLoading"
            class="button-fi__tertiary--large button-fi--icon button-fi__xs-streched"
            @click="downloadMedia(mediaDownloadLink)"
          >
            <icon-fi icon="download" />
            {{ fields.mediaDownloadDialogButton?.value }}
          </a>
        </loading-indicator-wrapper>
      </div>
    </template>
  </dialog-modal-fi>
</template>

<script>
import { DialogModalFi, IconFi, LoadingIndicatorWrapper, RichtextFi } from 'atoms';

import eventHubMixin from '@/mixins/eventHubMixin.vue';
// dynamic import because static import is not SSR compatible
const importFileSaver = () => import('file-saver');

export default {
  name: 'MediaDownloadDialogFi',
  components: {
    DialogModalFi,
    IconFi,
    LoadingIndicatorWrapper,
    RichtextFi,
  },
  mixins: [eventHubMixin],
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    mediaDownloadLink: {
      type: String,
      default: null,
    },
    fileName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      timer: null,
      attempts: 0,
    };
  },
  methods: {
    show() {
      this.$refs.dialog.open();
    },
    beforeClose() {
      this.isLoading = false;
      if (this.timer) {
        this.clearTimer();
      }
    },
    close() {
      this.$refs.dialog.close();
    },
    async downloadMedia(url) {
      if (IS_SSR) {
        return;
      }

      this.isLoading = true;
      this.sendEvent('custom', {}, 'download', {
        link: url,
        name: this.fileName,
      });
      const [response, FileSaver] = await Promise.all([fetch(url), importFileSaver()]);

      if (response?.status === 200) {
        this.isLoading = false;

        const fileName = `media-${this.fileName.replace(/\s+/g, '-')}.zip`;
        FileSaver.default.saveAs(await response.blob(), fileName);
      } else {
        this.timoutAndTryAgain();
      }
    },
    timoutAndTryAgain() {
      if (this.attempts < 9) {
        this.timer = setTimeout(() => {
          this.attempts += 1;
          this.downloadMedia(this.mediaDownloadLink);
        }, 1000);
      } else {
        this.handleErrorNotification();
      }
    },
    clearTimer() {
      clearTimeout(this.timer);
      this.timer = null;
      this.attempts = 0;
    },
    handleErrorNotification() {
      this.isLoading = false;
      this.close();

      this.$store.dispatch('notifications/openToastNotification', {
        message: this.fields.mediaDownloadDialogErrorText,
        type: 'error',
        icon: 'alert-triangle',
        persist: true,
      });
    },
  },
};
</script>

<style src="./media-download-dialog-fi" />
